/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
/* eslint-disable no-magic-numbers */
/* eslint-disable no-nested-ternary */
import * as Sentry from '@sentry/react'
import { Popover } from 'antd'
import debounce from 'lodash/debounce'
import uniq from 'lodash/uniq'
import chunk from 'lodash/chunk'
import pathRegexp from 'path-to-regexp'
import Qs from 'qs'
import { parse } from 'querystring'
import moment from 'moment'
import { getPropByName } from '@/components/PlatformList/components/labelIcon'
import {
    ECOLOGY_VERSION_CODE,
    LATITUDE_VERSION_CODE,
    ECOLOGY_VERSION,
    LATITUDE_VERSION,
    ECOLOGY_VERSION_TEXT,
    LATITUDE_VERSION_TEXT
} from '@/modules/globals/constants/version'
import { isFiniteNumber } from '@/utils/typeNarrowing'

import { getUUID } from './uuid'
import getRootDom from './getRootDom'

import gbk from '@/libs/gbk'
import pick from 'lodash/pick'
import isEqual from 'lodash/isEqual'
import { getIEVersion } from '@/utils/system'
import { getRootServer, getTerminaDomain } from './terminal'

import styles from './utils.less'

export { getRootDom, getUUID }

export const FALLBACK =
    'data:image/png;base64,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'

const reg =
    /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/
export const isUrl = path => reg.test(path)

export const isAntDesignPro = () => {
    return window.location.hostname === 'preview.pro.ant.design'
} // 给官方演示站点用，用于关闭真实开发环境不需要使用的特性

export const isAntDesignProOrDev = () => {
    const { NODE_ENV } = process.env

    if (NODE_ENV === 'development') {
        return true
    }

    return isAntDesignPro()
}
export const handlePercent = (decimal, fixedNum = 2) => {
    if (decimal === null || decimal === undefined) {
        return ''
    }
    if (typeof decimal !== 'number' && typeof Number(decimal) !== 'number') {
        return ''
    }

    // 将小数转换为百分数，保留两位小数
    const percentage = (decimal * 100).toFixed(fixedNum)

    // 将百分数字符串转换为浮点数，以便处理精度问题
    const parsedPercentage = parseFloat(percentage)

    // 检查小数位是否为0，如果是则转换为整数
    if (parsedPercentage === parseInt(parsedPercentage, 10)) {
        return parsedPercentage.toFixed(0) + '%'
    }

    return parsedPercentage + '%'
}
export const formatNumberWithW = (count, options) => {
    const { trimZeroDecimal, showPlus } = options || {}
    const num = Number(count)
    if (isNaN(num)) return count

    if (num > 9999 || num < -9999) {
        const value = num / 10000
        let formatted = ''
        if (trimZeroDecimal) {
            formatted = parseFloat(value.toFixed(2)).toString()
        } else {
            formatted = value % 1 === 0 ? value.toString() : value.toFixed(2)
        }

        const suffix = count > formatted * 10000 && showPlus ? '万+' : '万'
        return formatted + suffix
    }
    return count
}
export const getPageQuery = () => parse(window.location.href.split('?')[1])
/**
 * props.route.routes
 * @param router [{}]
 * @param pathname string
 */

export const getAuthorityFromRouter = (router = [], pathname) => {
    const authority = router.find(({ routes, path = '/' }) => {
        return (path && pathRegexp(path).exec(pathname)) || (routes && getAuthorityFromRouter(routes, pathname))
    })

    if (authority) {
        return authority
    }

    return undefined
}

export const codeSplit = str => {
    return (str && str.replace(/[,，\s\r\n]+/g, ',')) || ''
}

export const getAuthorityRouter = ({ router = [], pathname }) => {
    let authRes
    // eslint-disable-next-line no-shadow
    const filterRouter = (router = [], pathname) => {
        const authority = router.find(({ routes, path = '/' }) => {
            return (path && pathRegexp(path).exec(pathname)) || (routes && filterRouter(routes, pathname))
        })
        if (authority) {
            authRes = authority
            return false
        }
    }
    filterRouter(router, pathname)

    return authRes
}

export const getRouteAuthority = (path, routeData) => {
    let authorities
    routeData.forEach(route => {
        // match prefix
        if (pathRegexp(`${route.path}/(.*)`).test(`${path}/`)) {
            if (route.authority) {
                authorities = route.authority
            } // exact match

            if (route.path === path) {
                authorities = route.authority || authorities
            } // get children authority recursively

            if (route.routes) {
                authorities = getRouteAuthority(path, route.routes) || authorities
            }
        }
    })
    return authorities
}

export const getOrigin = () => {
    let origin

    if (!window.location.origin) {
        origin = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''
            }`
    } else {
        origin = window.location.origin
    }

    return origin
}

export const getDomain = () => {
    return window.location.hostname
}

export const createWindow = () => {
    const instance = window.open('', '_blank')

    instance.document.title = '正在加载...'
    instance.blur()

    const open = url => {
        instance.location.href = url
    }

    const close = () => {
        instance.close()
    }

    return {
        open,
        close
    }
}

export const submitForm = (url, data = {}) => {
    if (!url || Object.prototype.toString.call(data) !== '[object Object]') {
        return
    }

    const $form = document.createElement('form')

    $form.setAttribute('action', url)
    $form.setAttribute('method', 'POST')
    $form.style.display = 'none'

    Object.keys(data).forEach(key => {
        const $input = document.createElement('input')

        $input.setAttribute('name', key)
        $input.value = data[key]

        $form.appendChild($input)
    })

    document.body.appendChild($form)

    $form.submit()

    $form.parentNode.removeChild($form)
}

export const previewVideo = url => {
    return window.open(`${getOrigin()}/video?url=${url}`)
}

export async function queue(arr) {
    let res = []
    for (let fn of arr) {
        try {
            let uploadFun = fn()
            let data = await uploadFun
            res.push(data)
        } catch (err) {
            console.error('catchError', err)
        }
    }

    return await res
}

// 提取富文本图片链接
export const extractPicFromHtml = str => {
    const data = []

    str.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, (match, capture) => data.push(capture))

    return data
}

// 判断是图片还是视频
export const isImageOrVideo = str => {
    if (!str) {
        return
    }
    let newStr = str.split('?')?.[0] || str
    const index = newStr.lastIndexOf('.')
    const type = newStr.substring(index)
    const imgTypes = ['.bmp', '.png', '.gif', '.jpg', '.jpeg', '.BMP', '.PNG', '.GIF', '.JPG', '.JPEG']
    const videoTypes = ['.mp4', '.rmvb', '.avi', '.ts', '.MP4', '.RMVB', '.AVI', '.TS']
    if (imgTypes.indexOf(type) !== -1) {
        return 'image'
    } else if (videoTypes.indexOf(type) !== -1) {
        return 'video'
    } else {
        return
    }
}

// 判断是否json数组
export const isJsonString = str => {
    try {
        if (typeof JSON.parse(str) === 'object') {
            return true
        }
    } catch (e) {
        // console.error('catchError', e)
    }
    return false
}

/**
 * Convert an image
 * to a base64 url
 */
export const convertImgToBase64URL = (url, callback, outputFormat) => {
    let img = new Image()
    img.crossOrigin = 'Anonymous'
    img.onload = function () {
        let canvas = document.createElement('CANVAS')
        let ctx = canvas.getContext('2d')
        let dataURL
        canvas.height = img.height
        canvas.width = img.width
        ctx.drawImage(img, 0, 0)
        dataURL = canvas.toDataURL(outputFormat)
        callback(dataURL)
        canvas = null
    }
    img.src = url
}

export const base64ToBlob = (base64, contentType) => {
    let base64Str = ''
    let contentTypeStr = ''
    if (base64.indexOf('base64') !== -1) {
        let parts = base64.split(';base64,')
        base64Str = parts[1]
        contentTypeStr = contentType || parts[0].split(':')[1]
    } else {
        base64Str = base64
        contentTypeStr = contentType
    }

    let raw = window.atob(base64Str)
    let rawLength = raw.length

    let uInt8Array = new Uint8Array(rawLength)

    for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
    }
    return new Blob([uInt8Array], { type: contentTypeStr })
}

export const downBase64Img = (base64, fileName) => {
    let aLink = document.createElement('a')
    let blob = base64ToBlob(base64)
    let evt = document.createEvent('HTMLEvents')
    evt.initEvent('click', true, true)
    aLink.download = fileName
    aLink.href = URL.createObjectURL(blob)

    aLink.click()
}

// icon 排序
export const sortIcon = data => {
    const res = new Map()
    let sortArr = data.sort((m, n) => {
        if (m.icon && !n.icon) {
            return -1
        } else if (!m.icon && n.icon) {
            return 1
        } else {
            return 0
        }
    })
    // 过滤去掉icon相同的
    return sortArr.filter(item =>
        item.icon ? !res.has(item.icon) && res.set(item.icon, 1) : !res.has(item.label) && res.set(item.label, 1)
    )
}

// 轮询
export const poll = (
    callback,
    config = {
        immediately: false,
        duration: 1500,
        /** @type {number | undefined} 最大轮询次数 */
        max: 3000,
        /** @type {number | undefined} 首次轮询间隔时间，默认取 `duration` */
        firstDuration: undefined
    }
) => {
    let timer
    let count = 0
    let isClosed = false

    const clear = () => {
        isClosed = true
        timer && clearTimeout(timer)
    }

    const run = () => {
        if (isClosed) return

        timer && clearTimeout(timer)

        if (typeof config.max === 'number' && count > config.max) {
            return
        }

        let duration = config.duration
        const isFirst = config.immediately ? count === 1 : count === 0

        if (isFirst && Number.isFinite(config.firstDuration)) {
            duration = config.firstDuration
        }

        timer = setTimeout(() => {
            callback(run, clear, count)
            count++
        }, duration)
    }

    if (config.immediately) {
        callback(run, clear, count)
        count++
    } else {
        run()
    }

    return clear
}

// 延时
export const delay = ms =>
    new Promise(resolve => {
        setTimeout(resolve, ms)
    })

// 取url参数
export const getQueryVariable = (variable, url) => {
    let query = ''
    if (url) {
        const splits = url.split('?')
        query = Array.isArray(splits) && splits.length > 1 ? splits[1] : ''
    } else {
        query = window.location.search.substring(1)
    }

    let vars = query.split('&')
    for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split('=')
        if (pair[0] === variable) {
            return pair[1]
        }
    }
    return false
}

export const isJSON = str => {
    if (typeof str === 'string') {
        try {
            let obj = JSON.parse(str)
            if (typeof obj === 'object' && obj) {
                return true
            } else {
                return false
            }
        } catch (e) {
            console.error('catchError', e)
            return false
        }
    }
}

export const fucCheckLength = strTemp => {
    let length = 0

    if (strTemp) {
        const strGbk = gbk.encode(strTemp)

        length = strGbk.length
    }

    return length
}

export const fucCheckLength2 = strTemp => {
    if (strTemp) {
        // todo del log
        let arr = strTemp.split('')
        // 数字英文及半角符号为0.5个
        // 为中文全角符号算1个字符

        arr = arr.map(v => {
            // 半角
            if (v.match(/[\x00-\xff]/)) {
                return 0.5
            }

            // 全角
            if (v.match(/[^\x00-\xff]/)) {
                return 1
            }

            return 1
        })

        return arr.reduce((sum = 0, val) => Number(sum) + Number(val))
    }

    return 0
}

export const fucCheckLength3 = (strTemp, config) => {
    if (strTemp) {
        // todo del log
        let arr = strTemp.split('')
        // GBK长度计算: 中文为2字节，其余为1字节
        // UTF-8长度计算: 中文为3字节，其余为1字节

        arr = arr.map(v => {
            const code = v.charCodeAt(0)
            if (code >= 0 && code <= 128) {
                return 0.5
            } else {
                // 如果是中文则长度加2
                return 1
            }
        })

        if (config?.disableMathCeil) {
            return arr.reduce((sum = 0, val) => Number(sum) + Number(val))
        }

        // 向上取整
        return Math.ceil(arr.reduce((sum = 0, val) => Number(sum) + Number(val)))
    }

    return 0
}

export const fucCheckLength4 = (strTemp, config) => {
    if (strTemp) {
        let arr = strTemp.split('')
        // 中文 1，非中文都是 0.5

        arr = arr.map(v => {
            const code = /[\u4e00-\u9fa5]/.test(v)
            if (code) {
                return 1
            } else {
                return 0.5
            }
        })

        if (config?.disableMathCeil) {
            return arr.reduce((sum = 0, val) => Number(sum) + Number(val))
        }

        // 向上取整
        return Math.ceil(arr.reduce((sum = 0, val) => Number(sum) + Number(val)))
    }

    return 0
}

export const fucCheckLength5 = strTemp => {
    if (strTemp) {
        let arr = strTemp.split('')
        // 中文 2，非中文都是 1

        arr = arr.map(v => {
            const code = /[\u4e00-\u9fa5]/.test(v)
            if (code) {
                return 2
            } else {
                return 1
            }
        })

        return arr.reduce((sum = 0, val) => Number(sum) + Number(val))
    }

    return 0
}

// 计算字符串长度
export const calStrLen = (
    str,
    config = {
        strict: false,
        type: null,
        disableMathCeil: false
    }
) => {
    if (!config.strict) return str.length

    if (config.type === 2) return fucCheckLength2(str, config)

    if (config.type === 3) return fucCheckLength3(str, config)

    if (config.type === 4) return fucCheckLength4(str, config)

    // 中文 2，非中文都是 1
    if (config.type === 5) return fucCheckLength5(str)

    return fucCheckLength(str)
}

export { getRootServer, getTerminaDomain }

export const getCookiesDomain = () => {
    const rootServer = getRootServer()

    const canUseDomain = PROJECT_CONFIG.permissionHost.indexOf(rootServer) !== -1
    return canUseDomain ? rootServer : PROJECT_CONFIG.cookiesDomain
}

export const isNumber = v => {
    if (isNaN(v)) {
        return false
    }

    if (!isFinite(v)) {
        return false
    }

    const a = parseFloat(v)

    return !isNaN(a)
}

// 获取数字精度
export const getDecimalPrecision = number => {
    const numberString = number.toString()
    const decimalIndex = numberString.indexOf('.')

    if (decimalIndex === -1) {
        return 0 // 整数，没有小数部分
    } else {
        return numberString.length - decimalIndex - 1
    }
}

// html反转义
export const htmlDecode = str => {
    try {
        let s = ''
        if (str.length === 0) return ''
        s = str.replace(/&amp;/g, '&')
        s = s.replace(/&lt;/g, '<')
        s = s.replace(/&gt;/g, '>')
        s = s.replace(/&nbsp;/g, ' ')
        s = s.replace(/&#39;/g, "'")
        s = s.replace(/&quot;/g, '"')
        s = s.replace(/<br\/>/g, '\n')
        s = s.replace(/&apos;/g, "'")
        return s
    } catch (error) {
        console.error('htmlDecode', error, str)

        Sentry.setExtra('extra', {
            error,
            str
        })
        Sentry.captureException('htmlDecode 解析失败')

        return ''
    }
}

// 文字超出几个，显示查看更多
export const TextHandle = (text, num) => {
    if (typeof text === 'string') {
        if (text.length >= num) {
            return (
                <div>
                    <span>{text.substring(0, num)}</span>
                    <Popover overlayStyle={{ maxWidth: 300 }} content={text} trigger="click">
                        <span className={styles.moreText}>...查看更多</span>
                    </Popover>
                </div>
            )
        } else {
            return <div>{text}</div>
        }
    } else {
        return null
    }
}

// 滚动到顶部
export const scrollTop = () => {
    const $root = getRootDom()

    $root.scrollTop = 0
}

// 记录上次path
export const setReferrerUrl = referrerUrl => {
    window.referrerUrl = referrerUrl ? referrerUrl : ''
}

// 金额转千分并保留两位小数（如果小数点后是0也显示小数位）
export const amountTransferThousandth = (amount, num = 2) => {
    if (!isNumber(amount)) {
        return ''
    }
    return amount.toFixed(num).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
}
// 金额转千分并保留两位小数（如果小数点后是0则不显示小数位）
export const amountTransferThousandthSmart = (amount, num = 2) => {
    if (!isNumber(amount)) {
        return ''
    }

    const fixed = amount.toFixed(num)
    const [intPart, decimalPart] = fixed.split('.')

    const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

    return Number(decimalPart) === 0 ? formattedInt : `${formattedInt}.${decimalPart}`
}

/**
 *  ratio百分比*100 保留fixedNum位小数
 * @param {*} ratio
 * @param {number} fixedNum
 * @returns
 */
export const getRatioPercent = (ratio, fixedNum = 2) => {
    if (isFiniteNumber(ratio)) {
        return `${parseFloat((ratio * 100).toFixed(fixedNum))}%`
    }

    return '-'
}

// 数字转千分位
export const numTransferThousandth = num => {
    if (!isNumber(num)) {
        return ''
    }
    // eslint-disable-next-line no-return-assign
    return String(num).replace(/\d{1,3}(?=(\d{3})+$)/g, $1 => ($1 = `${$1},`))
}

export const lazy = debounce(fn => fn(), 1000)

export const lazyWithLeading = debounce(fn => fn(), 1000, { leading: true, trailing: false })

// 验证重复元素，有重复返回true；否则返回false
export const isRepeat = arr => {
    const hash = {}

    for (let i = 0; i < arr.length; i++) {
        if (hash[arr[i]]) {
            return true
        }

        hash[arr[i]] = true
    }

    return false
}

// 判断路由是否有权限 如果path是数组 只要其中一个有权限 就有权限
export const currentRouterHasAuth = (path, permissionList) => {
    if (!permissionList) {
        return true
    }
    if (!Array.isArray(permissionList)) {
        return true
    }
    const permissions = permissionList
        .filter(i => i.hasRole)
        .reduce((res, i) => {
            return [...res, ...(i.url || '').split(',')]
        }, [])

    if (Array.isArray(path)) {
        return path.some(i => permissions.indexOf(i) !== -1)
    }
    const hasAuth = permissions.indexOf(path) !== -1
    return hasAuth
}

// 判断设备类型
export const browser = {
    versions: (function () {
        const u = navigator.userAgent

        return {
            trident: u.indexOf('Trident') > -1, // IE内核
            presto: u.indexOf('Presto') > -1, // opera内核
            webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
            gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, // 火狐内核
            // mobile故意删掉了 ipad
            mobile:
                // /mobile|tablet|ip(hone|od)|android/i.test(u) ||
                // (us.indexOf('safari') > -1 && /Mac OS/i.test(u) && /Macintosh/i.test(u)),
                /(iPhone|iPad|iPod|iOS)/i.test(u) || /(Android)/i.test(u),
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, // android终端
            iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, // 是否iPad
            webApp: u.indexOf('Safari') === -1, // 是否web应该程序，没有头部与底部
            weixin: u.indexOf('MicroMessenger') > -1, // 是否微信 （2015-01-22新增）
            qq: u.match(/\sQQ/i) === 'qq' // 是否QQ
        }
    })(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
}

export const NUM_MAP = {
    0: '无',
    1: '一',
    2: '二',
    3: '三',
    4: '四',
    5: '五',
    6: '六',
    7: '七',
    8: '八',
    9: '九',
    10: '十'
}

export const transNum = num => NUM_MAP[String(num)]

export const getIsEmpty = value => value === null || value === '' || value === undefined

export const isNotEmptyObj = prop => {
    return Object.prototype.toString.call(prop) === '[object Object]' && Object.keys(prop).length
}

export const jsonString = val => {
    try {
        return JSON.stringify(val)
    } catch (e) {
        console.error('catchError', e)
        return ''
    }
}

export const toStringEqual = (prev, cur) => {
    const preStr = jsonString(prev)
    const curStr = jsonString(cur)

    return preStr === curStr
}

// 获取当前鼠标相对于document的高度
export const getScrollTop = () => {
    try {
        return getRootDom().scrollTop
    } catch (e) {
        console.error('catchError', e)
    }
}

// 设置当前滚动条高度
export const setCurrentScrollTop = () => {
    try {
        sessionStorage.setItem('scrollTop', getScrollTop())
    } catch (e) {
        console.error('catchError', e)
    }
}

// 滚动到上次位置
export const resetScrollTop = () => {
    try {
        // 判断上一个路由来源是否是子页面
        // const referrerUrl = document.referrer;
        // if(referrerUrl.indexOf(childPath)>-1){
        setTimeout(() => {
            // eslint-disable-next-line no-shadow
            const scrollTop = sessionStorage.getItem('scrollTop')
            if (scrollTop) {
                getRootDom().scrollTop = scrollTop
                sessionStorage.removeItem('scrollTop')
            }
        }, 500)
        // }
    } catch (e) {
        console.error('catchError', e)
    }
}

// 根据规则判断是否包含
export const includeByRule = (key, rule) => {
    // 数组
    if (Array.isArray(rule)) {
        return rule.includes(key)
    }

    // 正则
    if (rule instanceof RegExp) {
        return rule.test(key)
    }

    // 函数
    if (typeof rule === 'function') {
        return rule(key)
    }

    return false
}

// 从树中查找目标，结果为对象
export const findFromTree = (key, tree, config = { keyPropName: 'id', childrenPropName: 'children', leaf: false }) => {
    const { keyPropName, childrenPropName, leaf } = config

    for (let v of tree) {
        if (!leaf || !Array.isArray(v[childrenPropName])) {
            if (key === v[keyPropName]) {
                return v
            }
        }

        if (Array.isArray(v[childrenPropName]) && v[childrenPropName].length) {
            const res = findFromTree(key, v[childrenPropName], config)

            if (res) {
                return res
            }
        }
    }
}

// 解析url中的
export const parseUrl = url => {
    try {
        if (url.startsWith('http')) {
            const match1 = url.match(/^((?:http|https):\/\/[^/]+)(\/.+?)\?(.+)$/)

            if (match1) {
                return {
                    origin: match1[1],
                    pathname: match1[2],
                    query: match1[3] ? Qs.parse(match1[3]) : {}
                }
            }

            const match2 = url.match(/^((?:http|https):\/\/[^/]+)(\/.+)$/)

            if (match2) {
                return {
                    origin: match2[1],
                    pathname: match2[2],
                    query: {}
                }
            }

            return {
                origin: '',
                pathname: url,
                query: {}
            }
        }

        const qIndex = url.indexOf('?')
        const pathname = url.slice(0, qIndex)
        const query = url.slice(qIndex + 1)

        return {
            origin: getOrigin(),
            pathname,
            query: query ? Qs.parse(query) : {}
        }
    } catch (e) {
        console.error('catchError', e)
        Sentry.setExtra('exception', {
            error: e,
            url
        })
        Sentry.captureException('解析url失败 utils => parseUrl')

        return {
            origin: '',
            pathname: url,
            query: {}
        }
    }
}

// 过滤（件）（元）等数据
export const filterLabelsName = name => {
    return typeof name === 'string' ? name.replace(/\(件\)|\(元\)/g, '') : name
}
// 根据erpLabelsJson的code进行排序
export const sortByCode = (arr, codeArr) => {
    let result = []
    codeArr.forEach(item => {
        const findData = arr.find(subItem => subItem.code === item)
        if (findData) {
            result.push(findData)
        }
    })
    return result
}
/**
 * 转换服务能力数据(脱敏)
 */
export const formatServiceLabels = ({
    erpLabelsJson: value,
    maskDistributorCount,
    codes = ['6', '100', '101', '9', '5']
}) => {
    if (Array.isArray(value)) {
        let result = sortByCode(value, codes)
            .filter(item => {
                return codes.some(code => code === item.code)
            })
            .map(v => {
                if (v.code === '5') {
                    const places = v.labelDesc.split(',')
                    const newList = Array.from(new Set(places))
                    return newList[0]
                        ? { name: v.labelName, value: newList.join(',') }
                        : { name: v.labelName, value: '--' }
                } else if (v.code === '9') {
                    if (v.labelValue && v.labelValue.length) {
                        if (Number(v.labelValue[0]) >= 100) {
                            return { name: v.labelName, value: '--' }
                        } else {
                            return { name: v.labelName, value: v.labelDesc }
                        }
                    } else {
                        return { name: v.labelName, value: '--' }
                    }
                } else {
                    if (v.labelDesc) {
                        return {
                            name: v.labelName,
                            value: v.labelDesc,
                            color: v.code === '100' || v.code === '101' ? '#FA6400' : '#000'
                        }
                    } else {
                        return { name: v.labelName, value: '--' }
                    }
                }
            })
            .filter(Boolean)
        result.splice(3, 0, { name: '分销商数', value: maskDistributorCount ? maskDistributorCount : '--' })
        return result
    }
    return []
}

/**
 * 转换商品能力数据（脱敏）
 */
export const formatGoodsCapability = ({
    erpLabelsJson: value,
    maskSpuCount,
    maskSupplyAveragePrice,
    goodNewLabelName = '商品月上新'
}) => {
    if (Array.isArray(value)) {
        // 获取销售平均单价的值
        const saleAveragePriceItem = value.find(v => v.code === '3')
        const saleAveragePrice = saleAveragePriceItem && saleAveragePriceItem.labelDesc
        let result = sortByCode(value, ['8', '3', '4'])
            .filter(item => {
                return item.code === '8' || item.code === '4'
            })
            .map(v => {
                v.labelName = filterLabelsName(v.labelName)
                if (v.code === '4') {
                    if (v.labelDesc && v.labelDesc.indexOf('-') < 0) {
                        return { name: v.labelName, value: v.labelDesc }
                    } else {
                        return { name: v.labelName, value: '--' }
                    }
                } else if (v.code === '8') {
                    return { name: goodNewLabelName, value: v.labelDesc || '--' }
                } else {
                    if (v.labelDesc) {
                        return { name: v.labelName, value: v.labelDesc }
                    } else {
                        return { name: v.labelName, value: '--' }
                    }
                }
            })
            .filter(Boolean)
        result.unshift({
            name: '可分销商品',
            value: maskSpuCount ? maskSpuCount : '--',
            color: maskSpuCount ? '#FA6400' : ''
        })
        result.splice(2, 0, {
            name: '供货平均单价',
            value: maskSupplyAveragePrice ? maskSupplyAveragePrice : saleAveragePrice ? saleAveragePrice : '--'
        })
        return result
    }
    return []
}
/**
 * 转换分销平台数据
 */
export const findDistributorPlatform = value => {
    if (value) {
        let platformNameList = value.labelValue || []
        return platformNameList.length
            ? sortIcon(
                platformNameList.map(v => {
                    return {
                        ...getPropByName(v),
                        num: 0
                    }
                })
            )
            : []
    }
    return []
}

// 谷歌：'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/91.0.4472.114 Safari/537.36'
// Safari："Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.1 Safari/605.1.15"
// QQ："Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.25 Safari/537.36 Core/1.70.3870.400 QQBrowser/10.8.4405.400"
// 搜狗："Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/80.0.3987.87 Safari/537.36 SE 2.X MetaSr 1.0"

// Edge："Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/91.0.4472.114 Safari/537.36 Edg/91.0.864.59" (新版本)
// Edge："Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/64.0.3282.140 Safari/537.36 Edge/18.17763"

// 360极速："Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/86.0.4240.198 Safari/537.36"
// 360兼容："Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; .NET CLR 2.0.50727; .NET CLR 3.0.30729; .NET CLR 3.5.30729; rv:11.0) like Gecko"

export const uaMatch = ua => {
    const rwebkit = /(webkit)[\\/]([\w.]+)/
    const ropera = /(opera)(?:.*version)?[\\/]([\w.]+)/
    const rmsie = /(msie) ([\w.]+)/
    const rmozilla = /(mozilla)(?:.*? rv:([\w.]+))?/
    // Matches dashed string for camelizing
    // eslint-disable-next-line no-param-reassign
    ua = (ua || window.navigator.userAgent).toLowerCase()
    const match =
        rwebkit.exec(ua) ||
        ropera.exec(ua) ||
        rmsie.exec(ua) ||
        (ua.indexOf('compatible') < 0 && rmozilla.exec(ua)) ||
        []
    return {
        browser: match[1] || '',
        version: match[2] || '0'
    }
}

// 系统
export const getSystem = () => {
    const ua = navigator.userAgent.toLowerCase()

    if (ua.indexOf('mac') !== -1) {
        return 'mac'
    }

    if (ua.indexOf('window' !== -1)) {
        return 'window'
    }

    if (ua.indexOf('linux' !== -1)) {
        return 'linux'
    }

    return 'other'
}

export const isMac = () => {
    const system = getSystem()

    return system === 'mac'
}

// 获取浏览器信息
export const getBrowserInfo = () => {
    const ua = navigator.userAgent.toLowerCase()

    const system = getSystem()
    const ieVersion = getIEVersion()

    // IE
    if (ieVersion !== -1 && ieVersion !== 'edge') {
        return {
            ua,
            system,
            name: 'ie',
            version: ieVersion
        }
    }

    // 注意位置
    const arr = [
        { name: 'qq', test: /qqbrowser\/([\d.]+)/ }, // QQ
        { name: 'sogou', test: /metasr\s([\d.]+)/ }, // 搜狗
        { name: 'firefox', test: /firefox\/([\d.]+)/ }, // 火狐
        { name: 'opera', test: /opera.([\d.]+)/ }, // 欧朋
        { name: 'safari', test: /version\/([\d.]+).*safari/ }, // safari
        { name: 'edge', test: /(?:edge|edg)\/([\d.]+)/ }, // edge
        { name: 'chrome', test: /chrome\/([\d.]+)/ } // chrome
    ]

    for (let i = 0; i < arr.length; i++) {
        const cur = arr[i]
        const match = ua.match(cur.test)

        if (match) {
            return {
                ua,
                system,
                name: cur.name,
                version: match[1]
            }
        }
    }

    // 其它
    return {
        ua,
        system,
        name: 'other',
        version: '0'
    }
}

export const browserInfo = getBrowserInfo()

export const getFileType = fileName => {
    // 后缀获取
    let suffix = ''
    // 获取类型结果
    let result = ''
    try {
        const flieArr = fileName.split('.')
        suffix = flieArr[flieArr.length - 1]
    } catch (err) {
        console.error('catchError', err)
        suffix = ''
    } // fileName无后缀返回 false
    if (!suffix) {
        return false
    }
    suffix = suffix.toLocaleLowerCase()
    // 图片格式
    const imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
    // 进行图片匹配
    result = imglist.find(item => item === suffix)
    if (result) {
        return 'image'
    }
    // 匹配txt
    const txtlist = ['txt']
    result = txtlist.find(item => item === suffix)
    if (result) {
        return 'txt'
    }
    // 匹配 excel
    const excelist = ['xls', 'xlsx']
    result = excelist.find(item => item === suffix)
    if (result) {
        return 'excel'
    }
    // 匹配 word
    const wordlist = ['doc', 'docx']
    result = wordlist.find(item => item === suffix)
    if (result) {
        return 'word'
    }
    // 匹配 pdf
    const pdflist = ['pdf']
    result = pdflist.find(item => item === suffix)
    if (result) {
        return 'pdf'
    }
    // 匹配 ppt
    const pptlist = ['ppt', 'pptx']
    result = pptlist.find(item => item === suffix)
    if (result) {
        return 'ppt'
    }
    // 匹配 视频
    const videolist = ['mp4', 'm2v', 'mkv', 'rmvb', 'wmv', 'avi', 'flv', 'mov', 'm4v']
    result = videolist.find(item => item === suffix)
    if (result) {
        return 'video'
    }
    // 匹配 音频
    const radiolist = ['mp3', 'wav', 'wmv']
    result = radiolist.find(item => item === suffix)
    if (result) {
        return 'radio'
    }
    // 其他 文件类型
    return 'other'
}

// 过滤掉对象里value为空的值
export const filterEmptyQuery = data => {
    let param = {}
    for (let i in data) {
        if (data[i]) {
            param[i] = data[i]
        }
    }
    return param
}

// 是否往下执行
export const shouldRun = async (before, next) => {
    const p = before && before()

    if (typeof p === 'boolean') {
        if (p) {
            next()
        }
    } else if (p && p.then) {
        try {
            await p

            next()
        } catch (e) {
            console.error('catchError', e)
        }
    } else {
        next()
    }
}

export const isEmpty = val => {
    if (typeof val === 'number') {
        return false
    }

    if (typeof val === 'string') {
        return !val.replace(/\s+/g, '')
    }

    return !val
}

export const encodeSpecialStr = str => {
    if (typeof str === 'string') {
        return str.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
    }

    return ''
}
// 数组里是对象 去重
export const filterRepeat = (arr, id) => {
    let newobj = {}
    return arr.reduce((preVal, curVal) => {
        if (!newobj[curVal[id]]) {
            preVal.push(curVal)
        }
        return preVal
    }, [])
}

export const hasDuplicates = a => {
    return uniq(a).length !== a.length
}

/*
  支持中英文逗号分割
 */
export function splitByComma(text) {
    if (!text || typeof text !== 'string') return null
    const zhComma = '，'
    const comma = ','
    text = text.replaceAll(zhComma, comma)
    return text
        .split(comma)
        .filter(Boolean)
        .map(item => item.trim())
}

export const getAppVersionIconType = contractVersion => {
    let type = ''
    switch (contractVersion) {
        case ECOLOGY_VERSION:
        case ECOLOGY_VERSION_TEXT:
        case ECOLOGY_VERSION_CODE: {
            type = 'shengtaiban'
            break
        }
        case LATITUDE_VERSION:
        case LATITUDE_VERSION_TEXT:
        case LATITUDE_VERSION_CODE: {
            type = 'zonghengbiaozhunban'
            break
        }

        default:
            return null
    }

    return type
}
// 判断是否存在*号
export const isHasXing = str => {
    if (str?.indexOf('*') !== -1) {
        return true
    }
    return false
}

export function loadScriptSync(src) {
    return new Promise((resolve, reject) => {
        let script = document.createElement('script')
        script.type = 'text/javascript'
        script.async = true
        script.src = src
        document.body.appendChild(script)
        script.onerror = error => {
            reject(error)
        }
        script.onload = function () {
            resolve()
        }
    })
}
// 创建单例
export function getSingle(fn) {
    let result
    return function () {
        // eslint-disable-next-line no-return-assign, no-invalid-this
        return result || (result = fn.apply(this, arguments))
    }
}

export const underlineKeyWords = ({ title, value, color = '#aaa' }) => {
    const keyWordsArr = Array.isArray(value) ? value : [value]
    let keyWordsTitle = title
    keyWordsArr.forEach(item => {
        keyWordsTitle = keyWordsTitle.split(item).join(`<span style="color: ${color}">${item}</span>`)
    })
    return keyWordsTitle
}

// 计算两个时间之间的时间差
export const intervalTime = params => {
    const { startTime, endTime } = params || {}

    const timesTamp = Date.parse(new Date()) / 1000
    const startTimeStamp = startTime ? new Date(startTime).getTime() / 1000 : timesTamp
    const endTimeStamp = new Date(endTime).getTime() / 1000
    let date1 = ''

    if (timesTamp < startTimeStamp) {
        date1 = startTimeStamp
    } else {
        date1 = timesTamp
    }

    const date2 = endTimeStamp
    const date3 = (date2 - date1) * 1000

    const days = Math.floor(date3 / (24 * 3600 * 1000))

    const level1 = date3 % (24 * 3600 * 1000)
    let hours = Math.floor(level1 / (3600 * 1000))

    let level2 = level1 % (3600 * 1000)
    let minutes = Math.floor(level2 / (60 * 1000))

    let level3 = level2 % (60 * 1000)
    let seconds = Math.round(level3 / 1000)

    return {
        days,
        hours,
        minutes,
        seconds
    }
}
/**
 * 剩余发货时间（分钟数），不处理 0， 勿动！
 * @param minNum 正负分钟数值
 * @returns {null|string}
 */
export const transRemainingMinObj = minNum => {
    try {
        if (isNumber(minNum)) {
            let remainType = minNum <= 0 ? '已超时' : '快超时'
            let remainText = ''

            let n = ~~Math.abs(minNum)
            let min = n % 60
            let hour = (n - min) / 60

            if (hour > 24) {
                let day = ~~(hour / 24)
                remainText = `${day}天${hour % 24}小时${min}分`
            } else {
                remainText = `${hour}小时${min}分`
            }
            return {
                remainType,
                remainText
            }
        } else {
            return {
                remainType: '',
                remainText: ''
            }
        }
    } catch (error) {
        console.error('catchError', error)
    }
}

export const toPositiveFourDecimals = value => {
    value = value
        .replace(/[^\d]/g, '')
        .replace(/\.{2,}/g, '.')
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
    value = value.replace(/^(\-)*(\d+)\.(\d{4}).*$/, '$1$2.$3')
    value = value.replace(/^\./g, '')
    return value
}

export const lastNDays = (day, referenceTime) => {
    try {
        const reference = referenceTime ? moment(referenceTime).valueOf() : 0
        const targetTime = day * 24 * 60 * 60 * 1000
        const current = new Date(new Date().toLocaleDateString()).getTime()
        return current - reference <= targetTime
    } catch (error) {
        console.error('catchError', error)
    }
}

/**
 * 记录用户当日是否已经记录（记录在用户为度）
 * @param {Object} props - 属性对象
 * @param {string} props.uid - 用户ID
 * @param {string} props.key - 键
 */
export const showPopupIfAllowed = ({ uid, key }) => {
    if (!uid) {
        return false
    }
    // 获取当前日期（格式为YYYY-MM-DD）
    const currentDate = new Date().toISOString().split('T')[0]

    // 从localStorage中获取最后显示的日期
    const lastPopupDate = localStorage.getItem(`${key}_${uid}`)

    // 如果没有记录或日期不同，则显示弹框
    if (!lastPopupDate || lastPopupDate !== currentDate) {
        localStorage.setItem(`${key}_${uid}`, currentDate)
        return true
    } else {
        return false
    }
}

/**
 * 记录用户间隔days是否已经记录（记录在用户纬度）
 * @param {Object} props - 属性对象
 * @param {string} props.uid - 用户ID
 * @param {string} props.key - 键
 * @param {number} props.days - 天数
 */
export const showPopupIfAllowedOfDays = ({ uid, key, days }) => {
    if (!uid) {
        return false
    }
    // 获取当前日期（格式为YYYY-MM-DD）
    const currentDate = new Date().toISOString().split('T')[0]

    // 从localStorage中获取最后显示的日期
    const lastPopupDate = localStorage.getItem(`${key}_${uid}`)
    // 如果没有记录或日期不同，则显示弹框
    if (!lastPopupDate || currentDate.diff(lastPopupDate, 'days') >= days) {
        localStorage.setItem(`${key}_${uid}`, currentDate)
        return true
    } else {
        return false
    }
}

/**
 * 获取用户主动记录
 * @param {Object} props - 属性对象
 * @param {string} props.uid - 用户ID
 * @param {string} props.key - 键
 */
export const getUidAndDataLocalStorage = ({ uid, key }) => {
    if (!uid) {
        return false
    }
    // 获取当前日期（格式为YYYY-MM-DD）
    const currentDate = new Date().toISOString().split('T')[0]

    // 从localStorage中获取最后显示的日期
    const lastPopupDate = localStorage.getItem(`${key}_${uid}`)

    // 如果没有记录或日期不同，则显示弹框
    if (!lastPopupDate || lastPopupDate !== currentDate) {
        return true
    } else {
        return false
    }
}

/**
 * 记录在用户纬度，用户主动记录
 * @param {Object} props - 属性对象
 * @param {string} props.uid - 用户ID
 * @param {string} props.key - 键
 */
export const setUidAndDataLocalStorage = ({ uid, key }) => {
    if (!uid) {
        return false
    }
    // 获取当前日期（格式为YYYY-MM-DD）
    const currentDate = new Date().toISOString().split('T')[0]
    localStorage.setItem(`${key}_${uid}`, currentDate)
}
/**
 * 根据最大数量，分批请求
 * @param {Object} props - 属性对象
 * @param {string} props.promise - 请求函数
 * @param {string} props.paramArr - 请求参数数组
 * @param {string} props.maxLength - 最大数量
 */
export const splitRequest = async ({ promise, paramArr, maxLength = 500 }) => {
    const chunkArr = chunk(paramArr, maxLength)
    const results = await Promise.all(chunkArr?.map(item => promise(item)))
    if (results.every(v => v.success)) {
        return {
            success: true,
            data: results.map(v => v.data)
        }
    } else {
        const error = results.find(v => !v.success)
        return error
    }
}

/**
 * 获取嵌套属性的值
 * @param {Object} obj - 要提取属性的对象
 * @param {Array} path - 属性路径数组
 * @returns {*} - 返回属性值，如果路径无效则返回 undefined
 */
export const getNestedProperty = (obj, path) => {
    return path.reduce((acc, key) => acc && acc[key], obj)
}

/**
 * 转换 boolean 类型
 * @param {boolean|string} value - 需要转换的值
 * @returns {boolean}
 */
export function toBoolean(value) {
    if (value === true || value === 'true') {
        return true
    } else if (value === false || value === 'false') {
        return false
    }
    return !!value
}

// 快速比较2个列表的指定指
export const fastEqualList = (a, b, keys = []) => {
    try {
        const cleanA = a?.map(item => pick(item, keys))
        const cleanB = b?.map(item => pick(item, keys))

        return isEqual(cleanA, cleanB)
    } catch (error) {
        console.error('fastEqualGoodsSkuDetail', error)

        return false
    }
}
// 截取字符串str前bytes个字节
export const sliceByBytes = (str, bytes) => {
    let index = 0
    let tempBytes = 0
    for (let i = 0; i < str.length; i++) {
        const char = str.charAt(i)
        if (/[^\x00-\xff]/.test(char)) {
            tempBytes += 2
        } else {
            tempBytes += 1
        }
        if (tempBytes > bytes) {
            break
        } else {
            index += 1
        }
    }
    return str.slice(0, index)
}

// 拆分 29.8-1129.8
export const parsePriceRange = priceRange => {
    try {
        const iter = priceRange.matchAll(/(^|[^\d.])(-?\d+(?:\.\d+)?)/g)
        const nums = [...iter].map(m => parseFloat(m[2]))

        if (nums.length === 0) return { min: undefined, max: undefined }
        if (nums.length === 1) return { min: nums[0], max: nums[0] }
        return { min: nums[0], max: nums[1] }
    } catch (error) {
        console.error('parsePriceRange', error)
        return { min: undefined, max: undefined }
    }
}
